import React from "react";
import Navbar from "../../Components/Navigation/Navbar";
import { Button, Card, Table, Image } from "react-bootstrap";

function AssociationPage() {
  return (
    <>
      <Navbar />
      <Card>
        <Card.Header as="h5" className="text-center text-primary">
          Verbände
        </Card.Header>
        <Card.Body>
          <Card.Text className="text-center">
            Unser Verein ist Mitglied in allen für das Tauchen wichtigen Verbänden. Damit sind wir an das umfangreiche System von Information, Sportversicherung und Sportförderung dieser Dachverbände angeschlossen.
          </Card.Text>
          <Card.Text as="h6" className="text-primary">Wir sind Mitglied im:</Card.Text>
          <Table bordered hover responsive>
            <tbody>
              <tr>
                <td>
                  <p>Verband deutscher Sporttaucher e.V.<br />und dadurch im Weltverband des Tauchens CMAS</p>
                  <a href="https://www.vdst.de" target="_blank" rel="noopener noreferrer">
                    vdst.de
                  </a> <br />
                  <a href="https://www.cmas.org" target="_blank" rel="noopener noreferrer">
                    cmas.org
                  </a>
                </td>
                <td>
                  <a href="https://www.vdst.de" target="_blank" rel="noopener noreferrer">
                    <Image src="/vdst_logo.gif" alt="VDST Logo" />
                  </a>
                </td>
                <td>
                  <a href="https://www.cmas.org" target="_blank" rel="noopener noreferrer">
                    <Image src="/cmas.gif" alt="CMAS Logo" />
                  </a>
                </td>
              </tr>
              <tr>
                <td>Landessportbund Brandenburg e.V.<br /><a href="https://www.lsb-brandenburg.de" target="_blank" rel="noopener noreferrer">lsb-brandenburg.de</a></td>
                <td colSpan={2}>
                  <a href="https://www.lsb-brandenburg.de" target="_blank" rel="noopener noreferrer">
                    <Image src="/logo_lsb.gif" alt="LSB Logo" />
                  </a>
                </td>
              </tr>
              <tr>
                <td>Landestauchsportverband Brandenburg e.V.<br /><a href="https://www.ltsv-brandenburg.de" target="_blank" rel="noopener noreferrer">ltsv-brandenburg.de</a></td>
                <td colSpan={2}>
                  <a href="https://www.ltsv-brandenburg.de" target="_blank" rel="noopener noreferrer">
                    <Image src="/logo160_ltsvb.gif" alt="LTSV Logo" />
                  </a>
                </td>
              </tr>
              <tr>
                <td>SSV Stadtsportverband Hennigsdorf e.V.<br /><a href="https://www.ssv-hennigsdorf.de" target="_blank" rel="noopener noreferrer">ssv-hennigsdorf.de</a></td>
                <td colSpan={2}>
                  <a href="https://www.ssv-hennigsdorf.de" target="_blank" rel="noopener noreferrer">
                    <Image src="/ssv_logo.svg" alt="SSV Logo" />
                  </a>
                </td>
              </tr>
            </tbody>
          </Table>
        </Card.Body>
      </Card>

      <Card className="impressum mt-3">
        <Button variant="link" href="/impressum">Impressum</Button>
      </Card>
    </>
  );
}

export default AssociationPage;
